// JS code for Inspiratiepunten Canvas view.
import { Tile } from "./tile.js";
import { getCurrentTransform, easeOutQuad, pathData2X } from "./helper.js";
import { fetchData } from "./fetch-data.js";

document.addEventListener("DOMContentLoaded", () => {
  console.log("not-canvas.js v1.0.5");

  let debugVersionElm = null;
  
  if (!window.location.hostname.includes("rotterdamcirculair.nl")) {
    debugVersionElm = document.createElement('div');
    debugVersionElm.className = 'fixed bottom-0 right-0 px-4 py-2 bg-black text-white text-xs z-50 pointer-events-none';
    debugVersionElm.textContent = 'debug v1.3.1';
    document.body.appendChild(debugVersionElm);
  }

  const stadium = document.getElementById("inspiratie-stadium");
  const zoomStage = document.getElementById("inspiratie-stage-zoom");
  const stage = document.getElementById("inspiratie-stage");
  // Hint browser to promote these layers to the GPU compositor
  stage.style.willChange = "transform";
  zoomStage.style.willChange = "transform";
  const loadingOverlay = document.getElementById("loading-overlay");
  const buttonZoomIn = document.getElementById("button-zoom-in");
  const buttonZoomOut = document.getElementById("button-zoom-out");
  const buttonCentered = document.getElementById("button-centered");
  const zoomFactor = 0.1; // Zoom interval value
  const minScale = 0.5;
  const maxScale = 1;

  const n = 3.14159; // Pi
  const radius = 500; // Also serve as tiles gap
  const tiles = []; // Array to hold tile objects

  let tilesPerRing = Math.floor((radius * 2 * n) / radius); // Number of tiles for current ring
  let countTilesPerRing = 0; // Counter for tiles in current ring
  let ringCount = 1; // Start from ring 1
  let stageWidth = stadium.clientWidth;
  let stageHeight = stadium.clientHeight;
  let stageCenterX;
  let stageCenterY;
  let zoomScale = 1;

  let pos = { x: 0, y: 0 };

  // const tileSize = 150;
  // const colors = [
  //   "#175EC7",
  //   "#078941",
  //   "#42114A",
  //   "#D524A6",
  //   "#D1431F",
  //   "#935EB5",
  // ];

  loadingOverlay.style.display = "block";

  // Function to create tiles array
  function createTilesArray(posts) {
    clearTiles();
    
    stageCenterX = stageWidth / 2;
    stageCenterY = stageHeight / 2;

    const canvasMessage = document.getElementById("canvas-message");

    if (!posts || posts.length === 0) {
      console.log("No posts found. Showing empty canvas.");
      loadingOverlay.style.display = "none";

      if (canvasMessage) {
        canvasMessage.classList.remove("hidden");
      }

      return;
    }

    if (canvasMessage) {
      canvasMessage.classList.add("hidden");
    }

    tiles.push(
      new Tile(
        "0",
        posts[0].title,
        posts[0].imageUrl,
        stageCenterX,
        stageCenterY,
        posts[0].color,
        pathData2X[parseInt(posts[0].image_shape) - 1], // Field is 1,2,3 but array is 0,1,2
        stage,
        100,
        posts[0].permalink,
        posts[0].transitieagendaLabel
      )
    );

    for (let i = 1; i < posts.length; i++) {
      const angle = (countTilesPerRing / tilesPerRing) * 2 * n - n / 2;
      const tileOffsetX = radius * ringCount * Math.cos(angle) + stageCenterX;
      const tileOffsetY = radius * ringCount * Math.sin(angle) + stageCenterY;

      tiles.push(
        new Tile(
          i,
          posts[i].title,
          posts[i].thumbnailUrl,
          tileOffsetX,
          tileOffsetY,
          posts[i].color,
          pathData2X[parseInt(posts[i].image_shape) - 1],
          stage,
          100 + ringCount * 100,
          posts[i].permalink,
          posts[i].transitieagendaLabel
        )
      );

      countTilesPerRing++;
      if (countTilesPerRing >= tilesPerRing) {
        ringCount++;
        tilesPerRing = Math.floor((radius * ringCount * 2 * n) / radius);
        countTilesPerRing = 0;
      }
    }

    Promise.all(tiles.map(tile => tile.load()))
      .then(() => {
        loadingOverlay.style.display = "none";
        tiles.forEach(tile => tile.init());
        tiles.forEach(tile => observer.observe(tile.getElement()));
      })
      .catch(error => {
        console.error("Error loading images:", error);
        loadingOverlay.style.display = "none";
      });
  }

  // Fetch data depending on filters in URL
  window.addEventListener("load", async () => {
    const params = new URLSearchParams(window.location.search);

    // Build filters object from URL
    const filters = {
      keywords: params.getAll("keywords"),
      actueel_wijken: params.getAll("actueel_wijken"),
      transitieagenda: params.getAll("transitieagenda"),
    };

    // Check if any filter was actually applied
    const hasFilters =
      (filters.keywords && filters.keywords.length > 0) ||
      (filters.actueel_wijken && filters.actueel_wijken.length > 0) ||
      (filters.transitieagenda && filters.transitieagenda.length > 0);

    if (hasFilters) {
      // Trigger the same flow as UI apply
      document.dispatchEvent(
        new CustomEvent("filtersApplied", { detail: filters })
      );
      return; // stop here, don’t load defaults
    }

    // No filters -> normal default load
    const posts = await fetchData({
      nodeStatus: [true],
      page: 1,
      postsPerPage: 99999,
      publicView: true,
    });

    createTilesArray(posts);
  });

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const el = entry.target;
      const idx = el.getAttribute('data-idx');

      if (entry.isIntersecting) {
        tiles[parseInt(idx)].resumeWiggle(idx);
      } else {
        tiles[parseInt(idx)].pauseWiggle(idx);
      }
    });
  }, {
    root: null,       // viewport
    threshold: 0      // any visibility change triggers this
  });

  // PANNING (dragging) ////////////////////////////////////////////////////////////////////////////////
  let isDragging = false;
  let hasDragged = false; // Whether drag threshold has been exceeded
  let pointerDownPos = { x: 0, y: 0 }; // Where the pointer went down
  const dragThreshold = 1; // Pixels of movement before panning starts
  let startPos = { x: 0, y: 0 }; // For dragging use
  let dragStartTransform = { x: 0, y: 0 }; // Stage position captured at drag start (touch)
  const touchDragMultiplier = 1.5; // How much farther the stage travels vs finger movement
  let currentTransform = { x: 0, y: 0, scale: 1 }; // Stage's current transform values
  let velocity = { x: 0, y: 0 }; // For dragging use
  const touchVelocityScale = 32; // Scale factor for touch momentum
  let lastTime = 0; // For dragging use
  let animationFrameId = null; // requestAnimationFrame id
  let isPanning = false; // Is panning on-going

  // Rolling average velocity — samples the last N ms so momentum reflects
  // the overall gesture rather than a single erratic final event
  let velocityHistory = [];
  const velocityHistoryMs = 80;

  // Pinch-to-zoom state
  let pinchStartDist = 0;
  let pinchStartScale = 1;
  let pinchStartPos = { x: 0, y: 0 };
  let pinchCenter = { x: 0, y: 0 };

  const stadiumMouseDown = (e) => {
    isDragging = true;
    hasDragged = false;
    pointerDownPos = { x: e.clientX, y: e.clientY };
  }

  const stadiumMouseMove = (e) => {
    if (!isDragging) return;

    if (!hasDragged) {
      const dx = e.clientX - pointerDownPos.x;
      const dy = e.clientY - pointerDownPos.y;
      if (Math.hypot(dx, dy) < dragThreshold) return;
      // Threshold exceeded: initialize panning from the original pointer-down position
      hasDragged = true;
      stage.style.transition = ""; // clear any leftover CSS transition so rAF updates are instant
      stage.style.cursor = "grabbing";
      currentTransform.scale = getCurrentTransform(stage).scale;
      startPos = {
        x: pointerDownPos.x - currentTransform.x,
        y: pointerDownPos.y - currentTransform.y,
      };
      cancelAnimationFrame(animationFrameId);
    }

    isPanning = true;

    const now = performance.now();
    const deltaTime = now - (lastTime || now);
    lastTime = now;

    // Calculate new position
    const newX = e.clientX - startPos.x;
    const newY = e.clientY - startPos.y;

    // Calculate velocity for momentum (optional)
    velocity = {
      x: ((newX - currentTransform.x) / (deltaTime || 1)) * 16,
      y: ((newY - currentTransform.y) / (deltaTime || 1)) * 16,
    };

    currentTransform = { x: newX, y: newY, scale: currentTransform.scale };
    updateTransform();
  }

  const stadiumMouseUp = (e) => {
    isPanning = false;
    stage.style.cursor = "default";

    if (!isDragging) return;
    isDragging = false;

    // If the pointer never moved past the threshold it was a click — let it fire normally
    if (!hasDragged) return;

    // Was a drag: if the pointer is over a tile, intercept the upcoming click
    const tileEl = e.target.closest('div.iprt-html-tile');
    if (tileEl) {
      tileEl.addEventListener('click', (ev) => { ev.preventDefault(); ev.stopPropagation(); }, { once: true, capture: true });
    }

    applyMomentum();
  }

  stadium.addEventListener("mousedown", stadiumMouseDown, { passive: false });
  stadium.addEventListener("mousemove", stadiumMouseMove, { passive: false });
  stadium.addEventListener("mouseup", stadiumMouseUp, { passive: false });

  function updateTransform() {
    stage.style.transform = `translate3d(${currentTransform.x}px, ${currentTransform.y}px, 0px) scale3d(${currentTransform.scale}, ${currentTransform.scale}, ${currentTransform.scale})`;
  }

  function applyMomentum() {
    // Cap velocity so a hard straight swipe never feels jarring
    const maxVelocity = 22;
    velocity.x = Math.max(-maxVelocity, Math.min(maxVelocity, velocity.x));
    velocity.y = Math.max(-maxVelocity, Math.min(maxVelocity, velocity.y));

    const frictionMultiplier = (zoomScale - minScale) / (maxScale - minScale);
    // 0.90–0.96: gentler deceleration → longer, smoother ease-out glide
    const friction = 0.90 + (0.06 * frictionMultiplier);
    const threshold = 0.3; // Minimum velocity to keep animating

    const animate = () => {
      // Apply friction
      velocity.x *= friction;
      velocity.y *= friction;

      // Update position
      currentTransform.x += velocity.x;
      currentTransform.y += velocity.y;

      updateTransform();

      // Continue animation if velocity is above threshold
      if (
        Math.abs(velocity.x) > threshold ||
        Math.abs(velocity.y) > threshold
      ) {
        isPanning = true;
        animationFrameId = requestAnimationFrame(animate);
      } else {
        isPanning = false;
      }
    };

    animationFrameId = requestAnimationFrame(animate);
  }



























  let dragStartedTile = null;

  // Touch swipe handling for panning on touch devices
  const stadiumTouchStart = (e) => {
    if (e.touches.length === 2) {
      // Pinch gesture starting — cancel any active panning
      cancelAnimationFrame(animationFrameId);
      isDragging = false;
      const t1 = e.touches[0];
      const t2 = e.touches[1];
      pinchStartDist = Math.hypot(t2.clientX - t1.clientX, t2.clientY - t1.clientY);
      pinchStartScale = zoomScale;
      pinchStartPos = { x: pos.x, y: pos.y };
      const rect = stadium.getBoundingClientRect();
      pinchCenter = {
        x: (t1.clientX + t2.clientX) / 2 - rect.left,
        y: (t1.clientY + t2.clientY) / 2 - rect.top,
      };
      return;
    }
    if (e.touches.length !== 1) return;
    const touch = e.touches[0];

    if (dragStartedTile !== null) {
      dragStartedTile = null;
    }

    dragStartedTile = touch.target.closest('.iprt-html-tile');

    velocityHistory = []; // clear stale velocity from any previous gesture
    isDragging = true;
    hasDragged = false;
    pointerDownPos = { x: touch.clientX, y: touch.clientY };
    cancelAnimationFrame(animationFrameId);
  };

  const stadiumTouchMove = (e) => {
    // Handle pinch-to-zoom (2 fingers)
    if (e.touches.length === 2 && pinchStartDist > 0) {
      e.preventDefault();
      const t1 = e.touches[0];
      const t2 = e.touches[1];
      const dist = Math.hypot(t2.clientX - t1.clientX, t2.clientY - t1.clientY);
      const newScale = Math.max(minScale, Math.min(maxScale, pinchStartScale * (dist / pinchStartDist)));
      const zoomRatio = newScale / pinchStartScale;
      pos.x = pinchCenter.x - zoomRatio * (pinchCenter.x - pinchStartPos.x);
      pos.y = pinchCenter.y - zoomRatio * (pinchCenter.y - pinchStartPos.y);
      zoomScale = newScale;
      scrollZoom.update();
      updateZoomButtonState();
      return;
    }

    if (!isDragging || e.touches.length !== 1) return;

    if (dragStartedTile !== null && !dragStartedTile.classList.contains("drag-started-on")) {
      document.querySelectorAll('.is-tapped').forEach(tile => tile.classList.remove('is-tapped'));
      document.querySelectorAll('.drag-started-on').forEach(tile => tile.classList.remove('drag-started-on'));
      dragStartedTile.classList.add("drag-started-on");
    }

    const touch = e.touches[0];

    if (!hasDragged) {
      const dx = touch.clientX - pointerDownPos.x;
      const dy = touch.clientY - pointerDownPos.y;
      if (Math.hypot(dx, dy) < dragThreshold) return; // Not enough movement yet — let taps fire normally
      // Threshold exceeded: initialize panning from the original pointer-down position
      hasDragged = true;
      stage.style.transition = ""; // clear any leftover CSS transition so rAF updates are instant
      stage.style.cursor = "grabbing";
      currentTransform.scale = getCurrentTransform(stage).scale;
      dragStartTransform = { x: currentTransform.x, y: currentTransform.y };
      startPos = {
        x: pointerDownPos.x - currentTransform.x,
        y: pointerDownPos.y - currentTransform.y,
      };
    }

    e.preventDefault(); // Suppress scroll/overscroll/click only when actually panning
    isPanning = true;
    const now = performance.now();
    const deltaTime = now - (lastTime || now);
    lastTime = now;
    // Amplify finger delta by touchDragMultiplier so stage travels farther than the finger
    const newX = dragStartTransform.x + (touch.clientX - pointerDownPos.x) * touchDragMultiplier;
    const newY = dragStartTransform.y + (touch.clientY - pointerDownPos.y) * touchDragMultiplier;

    // Velocity multiplier: lerps from 64 at min zoom to 8 at max zoom
    const t = (zoomScale - minScale) / (maxScale - minScale);
    const velocityMultiplier = touchVelocityScale * (2.0 - 1.75 * t);

    const instantVx = ((newX - currentTransform.x) / (deltaTime || 1)) * velocityMultiplier;
    const instantVy = ((newY - currentTransform.y) / (deltaTime || 1)) * velocityMultiplier;

    // Push sample and drop entries older than velocityHistoryMs
    velocityHistory.push({ vx: instantVx, vy: instantVy, t: now });
    while (velocityHistory.length > 1 && now - velocityHistory[0].t > velocityHistoryMs) {
      velocityHistory.shift();
    }

    // Use rolling average so momentum reflects the whole gesture, not a single frame
    velocity = {
      x: velocityHistory.reduce((s, v) => s + v.vx, 0) / velocityHistory.length,
      y: velocityHistory.reduce((s, v) => s + v.vy, 0) / velocityHistory.length,
    };

    currentTransform = { x: newX, y: newY, scale: currentTransform.scale };
    updateTransform();
  };

  const stadiumTouchEnd = (e) => {
    pinchStartDist = 0; // reset pinch state

    isPanning = false;
    stage.style.cursor = "default";
    if (!isDragging) {
      return;
    }
    isDragging = false;
    applyMomentum();
  };

  stadium.addEventListener('touchstart', stadiumTouchStart, { passive: false });
  stadium.addEventListener('touchmove', stadiumTouchMove, { passive: false });
  stadium.addEventListener('touchend', stadiumTouchEnd, { passive: false });
  // Touch swipe handling for panning on touch devices END
  // PANNING (dragging) //////////////////////////////////////////////////////////////////////////// END






















  
  function resetStage() {
    tilesPerRing = Math.floor((radius * 2 * n) / radius); // Number of tiles for current ring
    countTilesPerRing = 0;
    ringCount = 1;
    zoomScale = 1;

    isDragging = false;
    currentTransform = { x: 0, y: 0, scale: zoomScale };
    velocity = { x: 0, y: 0 };
    lastTime = 0;
    isPanning = false;

    pos = { x: 0, y: 0 };

    if (animationFrameId) cancelAnimationFrame(animationFrameId);
    animationFrameId = null;

    stage.style.transform = 'none';

    stageWidth = stadium.clientWidth;
    stageHeight = stadium.clientHeight;

    zoomStage.style.transform = `translate3d(0px, 0px, 0px) scale3d(${maxScale}, ${maxScale}, ${maxScale})`;

    buttonZoomIn.setAttribute('disabled', 'disabled');
    buttonZoomIn.classList.add("pointer-events-none", "opacity-30");
    buttonZoomOut.removeAttribute('disabled');
    buttonZoomOut.classList.remove("pointer-events-none", "opacity-30");
  }

  function clearTiles() {
    observer.disconnect();

    tiles.forEach((tile, index) => {
      tile.remove();
      tiles[index] = null;
    });

    tiles.length = 0;
  }

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      console.log('Page was restored from the bfcache (back/forward cache)');
      document.getElementById('iprt-page-transition').style.pointerEvents = 'none';
      document.getElementById('iprt-page-transition').classList.remove('active');
    } else {
      console.log('Normal load');
    }
  });

  // Handling zoom with mouse wheel
  function ScrollZoom() {
    const stadiumRect = stadium.getBoundingClientRect();

    const target = zoomStage;
    var zoom_target = { x: 0, y: 0 };
    var zoom_point = { x: 0, y: 0 };

    target.style.transformOrigin = "0 0";

    stadium.addEventListener("wheel", scrolled, { passive: false });

    function scrolled(e) {
      e.preventDefault();

      var stadiumRect = stadium.getBoundingClientRect();
      var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      zoom_point.x = e.pageX - stadiumRect.left - scrollLeft;
      zoom_point.y = e.pageY - stadiumRect.top - scrollTop;

      var delta = e.deltaY || e.detail || e.wheelDelta;
      delta = delta > 0 ? -1 : 1; // normalize: scroll down to zoom out

      // determine the point on where the slide is zoomed in
      zoom_target.x = (zoom_point.x - pos.x) / zoomScale;
      zoom_target.y = (zoom_point.y - pos.y) / zoomScale;

      // apply zoom
      zoomScale += delta * zoomFactor * zoomScale;
      zoomScale = Math.max(minScale, Math.min(maxScale, zoomScale));

      // calculate new position to keep zoom centered around cursor
      pos.x = -zoom_target.x * zoomScale + zoom_point.x;
      pos.y = -zoom_target.y * zoomScale + zoom_point.y;

      updateZoomButtonState();

      update();
    }

    function update() {
      target.style.transform = "translate(" + pos.x + "px," + pos.y + "px) scale(" + zoomScale + ")";
    }

    buttonZoomIn.addEventListener('click', function () {
      buttonZoom('in');
      buttonZoomOut.removeAttribute('disabled');
      buttonZoomOut.classList.remove("pointer-events-none", "opacity-30");
    });

    buttonZoomOut.addEventListener('click', function () {
      buttonZoom('out');
      buttonZoomIn.removeAttribute('disabled');
      buttonZoomIn.classList.remove("pointer-events-none", "opacity-30");
    });

    function buttonZoom(zoomDirection, zoomFactor = 0.25) {
      var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      // Set the zoom point to the center of the stadium
      zoom_point.x = (stadiumRect.width / 2) - stadiumRect.left - scrollLeft;
      zoom_point.y = (stadiumRect.height / 2) - stadiumRect.top - scrollTop;

      // determine the point on where the slide is zoomed in (center of the stadium)
      zoom_target.x = (zoom_point.x - pos.x) / zoomScale;
      zoom_target.y = (zoom_point.y - pos.y) / zoomScale;


      const diff = zoomDirection === 'in' ? zoomFactor : -zoomFactor;
      let newScale = zoomScale + diff;

      if (newScale < minScale) { newScale = minScale; }
      if (newScale > maxScale) { newScale = maxScale; }

      zoomScale = newScale;

      // calculate new position to keep zoom centered around center of stadium
      pos.x = -zoom_target.x * zoomScale + zoom_point.x;
      pos.y = -zoom_target.y * zoomScale + zoom_point.y;

      update();

      updateZoomButtonState();
    }

    return { buttonZoom, update };
  }

  buttonCentered.addEventListener('click', function () {
    resetStage();
  });

  document.addEventListener("filtersApplied", async (e) => {
    const values = e.detail;
    const posts = await fetchData(values);

    document.dispatchEvent(new CustomEvent("fetchDataCompleted", {
      detail: "Fetch data completed"
    }));

    setTimeout(() => {
      resetStage();
      createTilesArray(posts);
    }, 500);
  });

  function updateZoomButtonState() {
    if (zoomScale <= minScale) {
      buttonZoomOut.setAttribute('disabled', 'disabled');
      buttonZoomOut.classList.add("pointer-events-none", "opacity-30");
    } else {
      buttonZoomOut.removeAttribute('disabled');
      buttonZoomOut.classList.remove("pointer-events-none", "opacity-30");
    }

    if (zoomScale >= maxScale) {
      buttonZoomIn.setAttribute('disabled', 'disabled');
      buttonZoomIn.classList.add("pointer-events-none", "opacity-30");
    } else {
      buttonZoomIn.removeAttribute('disabled');
      buttonZoomIn.classList.remove("pointer-events-none", "opacity-30");
    }

    // if (debugVersionElm) {
    //   debugVersionElm.textContent = `zoomScale: ${zoomScale.toFixed(2)}`;
    // }
  }

  // Handle window resize
  window.addEventListener("resize", () => {
    // Update stage dimensions
    stageWidth = stadium.clientWidth;
    stageHeight = stadium.clientHeight;
    // Update stage center coordinates
    stageCenterX = stageWidth / 2;
    stageCenterY = stageHeight / 2;

    tilesPerRing = Math.floor((radius * 2 * n) / radius);
    countTilesPerRing = 0;
    ringCount = 1;

    // Update tile positions
    tiles.forEach((tile, index) => {
      if (index === 0) {
        // Center tile
        tile.updateXY(stageCenterX, stageCenterY);
      } else {
        const angle = (countTilesPerRing / tilesPerRing) * 2 * n - n / 2;
        const tileOffsetX = radius * ringCount * Math.cos(angle) + stageCenterX;
        const tileOffsetY = radius * ringCount * Math.sin(angle) + stageCenterY;

        tile.updateXY(tileOffsetX, tileOffsetY);

        countTilesPerRing++;
        if (countTilesPerRing >= tilesPerRing) {
          ringCount++;
          tilesPerRing = Math.floor((radius * ringCount * 2 * n) / radius);
          countTilesPerRing = 0;
        }
      }
    });
  });

  resetStage(); // Initial reset to set correct dimensions and transform

  var scrollZoom = new ScrollZoom();

  const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  if (windowWidth < 768) {
    setTimeout(() => {
      scrollZoom.buttonZoom('out');
      setTimeout(() => {
        scrollZoom.buttonZoom('out');
      }, 100);
    }, 300);
  }

  // Map disclaimer tooltip
  const tooltipKey = "inspiratiepunten-canvas-tooltip";
  const disclaimerDismissed = localStorage.getItem(tooltipKey);

  if (disclaimerDismissed === 'dismissed') {
    const tooltip = document.getElementById('inspiratiepunten-canvas-tooltip');
    if (tooltip) tooltip.remove();
  } else {
    setTimeout(() => {
      const tooltip = document.getElementById('inspiratiepunten-canvas-tooltip');
      if (tooltip) {
        tooltip.style.display = 'flex';
        setTimeout(() => {
          tooltip.style.opacity = 1;
        }, 10);

        const closeBtn = document.getElementById('canvas-tooltip-close');
        if (closeBtn) {
          closeBtn.addEventListener('click', function () {
            localStorage.setItem(tooltipKey, 'dismissed');
            // Fade out
            let opacity = 1;
            tooltip.style.opacity = 0;
            setTimeout(() => {
              tooltip.style.display = 'none';
              tooltip.remove();
            }, 1000);
          });
        }
      }
    }, 2000);
  }

  // Prevent overscroll bounce on mobile when panning
  // document.body.addEventListener('touchmove', (e) => e.preventDefault(), { passive: false });

  // document.body.addEventListener("touchmove",(function(t){
  //   if (t.target.closest("#transitieagenda-scroll-container")) { return }
    
  //   t.preventDefault()
  // }),{ passive: false });

  // setTimeout(() => {
  //   console.clear();
  // }, 2000);
});
